// extracted by mini-css-extract-plugin
export default {"container":"container___jjjLW","header":"header____EM_E","componentName":"componentName___sh5h0","dark":"dark___jAvGm"};